// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CarouselItem_container__mDOav {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.CarouselItem_img__A5TwV {
  object-fit: cover;
  object-position: center center;
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/Carousel/CarouselItem.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd","sourcesContent":[".container {\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n.img {\r\n  object-fit: cover;\r\n  object-position: center center;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CarouselItem_container__mDOav`,
	"img": `CarouselItem_img__A5TwV`
};
export default ___CSS_LOADER_EXPORT___;
